var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Spacer } from '@lux/tokens';
import styled from 'styled-components';
export var ResponsiveCarouselWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var $isOverflowCarousel = _a.$isOverflowCarousel;
    return $isOverflowCarousel ? "padding: 0 ".concat(Spacer.XS, ";") : 'padding: 0;';
});
var templateObject_1;
